// src/services/ProductInfoServices.js
import api from "../api/api";

const normalizeList = (res) => {
  const d = res?.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(d?.data?.data)) return d.data.data;
  if (Array.isArray(d?.items)) return d.items;

  return [];
};

const normalizeItem = (res) => {
  const d = res?.data;
  if (d && typeof d === "object" && d.data && typeof d.data === "object" && !Array.isArray(d.data)) {
    return d.data;
  }
  return d;
};

const ProductInfoServices = {
  async getByProductId(product_id, options = {}) {
    const params = {
      product_id,
      ...options,
    };
    const res = await api.get("/product-info", { params });
    return normalizeList(res);
  },
};

export default ProductInfoServices;
